import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import {
  ArcElement,
  Chart,
  ChartData,
  ChartOptions,
  ChartType,
  DoughnutController,
  Legend,
  Tooltip,
} from 'chart.js';

Chart.register(DoughnutController, ArcElement, Tooltip, Legend);

@Component({
  selector: 'app-half-donut',
  standalone: true,
  imports: [CommonModule, BaseChartDirective],
  templateUrl: './half-donut.component.html',
  styleUrls: ['./half-donut.component.scss'],
})
export class HalfDonutComponent implements OnChanges {
  @Input() value = 0;
  @Input() text = 'Completado';

  public doughnutChartType: ChartType = 'doughnut';
  public displayValue = 0;
  public remainder = 100;

  public doughnutChartData: ChartData<'doughnut'> = {
    labels: ['Valor', 'Restante'],
    datasets: [
      {
        data: [0, 100],
        backgroundColor: ['#2f80ed', '#e5e7eb'],
        borderWidth: 0,
      },
    ],
  };

  public doughnutChartOptions: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: false,
    rotation: -90,
    circumference: 180,
    cutout: '75%',
    animation: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      const safeValue = Math.max(0, Math.min(100, Number(this.value) || 0));

      this.displayValue = safeValue;
      this.remainder = 100 - safeValue;

      this.doughnutChartData = {
        labels: [this.text, 'Restante'],
        datasets: [
          {
            data: [safeValue, this.remainder],
            backgroundColor: ['#2f80ed', '#e5e7eb'],
            borderWidth: 0,
          },
        ],
      };
    }

    if (changes.label && !changes.value) {
      this.doughnutChartData = {
        labels: [this.text, 'Restante'],
        datasets: [
          {
            data: [this.displayValue, this.remainder],
            backgroundColor: ['#2f80ed', '#e5e7eb'],
            borderWidth: 0,
          },
        ],
      };
    }
  }
}
